/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Invitation_RevokedInputs */

const fr_api_invitation_revoked = /** @type {(inputs: Api_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation annulée. Demandez-en une nouvelle à un administrateur.`)
};

const en_api_invitation_revoked = /** @type {(inputs: Api_Invitation_RevokedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation cancelled. Ask an administrator for a new one.`)
};

/**
* | output |
* | --- |
* | "Invitation cancelled. Ask an administrator for a new one." |
*
* @param {Api_Invitation_RevokedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_invitation_revoked = /** @type {((inputs?: Api_Invitation_RevokedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Invitation_RevokedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_invitation_revoked(inputs)
	return fr_api_invitation_revoked(inputs)
});